import React from 'react';
import { Box } from '@common-fe/common-fe';

import { useInvestor } from '../../hooks';
import { InvestmentPaths } from '../../investments.types';
import { useGetInvestorAccountId } from '../hook';
import InvestmentsFooter from '../InvestmentsFooter';

import MoneyTransfers from './MoneyTransfers';
import TransactionsHistory from './TransactionsHistory';

const Activities = () => {
  const accountId = useGetInvestorAccountId();
  const {
    data: { type },
  } = useInvestor(accountId);

  return (
    <Box direction="column" data-testid="activities">
      {type === InvestmentPaths.MANAGED && (
        <Box margin={{ bottom: 'spacing24' }}>
          <MoneyTransfers />
        </Box>
      )}

      <TransactionsHistory />

      <InvestmentsFooter />
    </Box>
  );
};

export default Activities;
